var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'show': _vm.shouldShow},attrs:{"id":"exporo-siri-root"}},[_c('p',[_vm._v(_vm._s(_vm.speechingText))])])}
var staticRenderFns = []

export { render, staticRenderFns }